// Mock data for Imperial Craft website

export const businessInfo = {
  name: "Imperial Craft",
  tagline: "Expert Kitchen & Bathroom Installation in West Midlands",
  phone: "07894 208 183",
  email: "Imperialcraftsman@gmail.com",
  location: "West Midlands, UK",
  logo: "https://customer-assets.emergentagent.com/job_home-fitting-pro/artifacts/uhuon3v9_Screenshot_20251014_121417_Gallery.jpg"
};

export const services = [
  {
    id: 1,
    title: "Kitchen Installation",
    description: "Complete kitchen fitting services including custom cabinetry, solid surface worktops, and appliance installation. We transform your space into a functional, beautiful kitchen.",
    icon: "ChefHat",
    image: "https://images.unsplash.com/photo-1730991568658-ad8638395a9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVuJTIwaXNsYW5kfGVufDB8fHx8MTc2MDQ0MjY0MHww&ixlib=rb-4.1.0&q=85",
    features: ["Custom Cabinetry", "Solid Surface Professional", "Worktop Installation", "Appliance Fitting", "Tiling & Splashbacks"]
  },
  {
    id: 2,
    title: "Bathroom Installation",
    description: "Professional bathroom fitting from design to completion. Including tiling, flooring, sanitaryware, and modern fixtures for your dream bathroom.",
    icon: "Bath",
    image: "https://images.unsplash.com/photo-1638799869566-b17fa794c4de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYXRocm9vbXxlbnwwfHx8fDE3NjA0NDIwODd8MA&ixlib=rb-4.1.0&q=85",
    features: ["Tiling & Flooring", "Sanitaryware Installation", "Shower & Bath Fitting", "Modern Fixtures"]
  },
  {
    id: 3,
    title: "Bedroom Installation",
    description: "Bespoke bedroom fitting with custom wardrobes, storage solutions, and quality finishes to maximize your space and style.",
    icon: "BedDouble",
    image: "https://images.unsplash.com/photo-1760072513393-b9d81f65dd7e",
    features: ["Custom Wardrobes", "Storage Solutions", "Quality Finishes", "Space Optimization"]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_home-fitting-pro/artifacts/fyhskvo3_20211004_120325_6e5e1746-a28a-45bd-b0f1-e5425eb8009b.jpg",
    title: "Modern Kitchen Installation",
    category: "kitchen"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_home-fitting-pro/artifacts/2qix1j76_20211004_120326_a12d79b0-adf0-4353-a76b-c26cad9d5ac6.jpg",
    title: "Kitchen with Range Hood & Worktop",
    category: "kitchen"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_home-fitting-pro/artifacts/ch6ha4sj_20211004_120327_cd1b65a2-f4dc-4698-8763-186b8681675b.jpg",
    title: "Solid Surface Worktop with Integrated Sink",
    category: "kitchen"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_home-fitting-pro/artifacts/q34r7nbu_20211004_120327_d13ff413-021d-43fa-aa5d-18625ad3242a.jpg",
    title: "Kitchen Worktop with Floating Shelves",
    category: "kitchen"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_home-fitting-pro/artifacts/hb863jg3_20250316_132844.jpg",
    title: "Modern Shower with Hexagonal Tiles",
    category: "bathroom"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_home-fitting-pro/artifacts/s1l14825_20250316_133041.jpg",
    title: "Walk-in Shower with Designer Tiles",
    category: "bathroom"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_home-fitting-pro/artifacts/12i27xh3_IMG-20250312-WA0006.jpg",
    title: "Luxury Walk-in Shower with Marble Effect Tiles",
    category: "bathroom"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_home-fitting-pro/artifacts/eqnn7204_IMG-20250928-WA0015.jpg",
    title: "Modern Bathroom with LED Lighting & Designer Fixtures",
    category: "bathroom"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_home-fitting-pro/artifacts/ux8quetq_IMG-20250718-WA0003%281%29.jpg",
    title: "Contemporary Bathroom with Wood Effect Flooring",
    category: "bathroom"
  },
  {
    id: 10,
    url: "https://images.pexels.com/photos/6903150/pexels-photo-6903150.jpeg?cs=srgb&dl=pexels-heyho-6903150.jpg&fm=jpg",
    title: "Grey Gloss Fitted Wardrobes",
    category: "bedroom"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_home-fitting-pro/artifacts/c9mya0u5_Screenshot_20251014_135406_Gallery.jpg",
    title: "Custom Fitted Bedroom Wardrobes",
    category: "bedroom"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Birmingham",
    rating: 5,
    text: "Imperial Craft transformed our kitchen beyond our expectations. The attention to detail and quality of workmanship is outstanding. Highly recommended!",
    service: "Kitchen Installation"
  },
  {
    id: 2,
    name: "James Thompson",
    location: "Wolverhampton",
    rating: 5,
    text: "Professional service from start to finish. Our new bathroom is absolutely stunning. The team was clean, punctual, and delivered on time.",
    service: "Bathroom Installation"
  },
  {
    id: 3,
    name: "Emma Davies",
    location: "Coventry",
    rating: 5,
    text: "We had both our kitchen and bathroom fitted by Imperial Craft. Excellent craftsmanship and customer service throughout. Worth every penny!",
    service: "Kitchen & Bathroom Installation"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Expert Craftsmanship",
    description: "Years of experience delivering high-quality installations across West Midlands",
    icon: "Award"
  },
  {
    id: 2,
    title: "Quality Materials",
    description: "We use only premium materials and fittings to ensure lasting beauty and durability",
    icon: "CheckCircle2"
  },
  {
    id: 3,
    title: "Competitive Pricing",
    description: "Excellent value without compromising on quality. Free, no-obligation quotes",
    icon: "DollarSign"
  },
  {
    id: 4,
    title: "Reliable Service",
    description: "Punctual, professional, and committed to completing projects on time and budget",
    icon: "Clock"
  }
];